module.exports = function(_) {

var is = _.is

_.isString = is.string

_.isArray = is.array

_.isArrayLike = is.arraylike

_.isBoolean = is.bool

_.isElement = is.element

_.isEmpty = is.empty

_.isFunction = is.fn

_.isInteger = is.integer

_.isNaN = is.nan

_.isNumber = is.number

_.isObject = is.object

_.isPlainObject = is.plainObject

_.isRegExp = is.regexp

_.isString = is.string

_.isUndefined = is.undef

}



//////////////////
// WEBPACK FOOTER
// ./node_modules/min-util/src/lang.js
// module id = 66
// module chunks = 0